import {
  AlertModal,
  Button,
  Icon,
  InformationCard,
  SafeHtmlContent
} from '@yes.technology/react-toolkit'
import { InnerText, OuterContainer } from './CancelModal.styles'
import { useTranslation } from 'react-i18n-lite'
import useCancelModal from './useCancelModal'

function CancelModal() {
  const { t } = useTranslation()

  const { isOpen, onSuccess, onCancel } = useCancelModal()

  return (
    <AlertModal
      isOpen={isOpen}
      onCancel={onCancel}
      onSuccess={onSuccess}
      mainMessage={t('object-view.cancel-edit-modal.main-message')}
      helpMessage={t('object-view.cancel-edit-modal.help-message')}
      returnButtonMessage={t('object-view.cancel-edit-modal.return')}
      cancelButtonMessage={t('object-view.cancel-edit-modal.cancel')}
    />
  )
}

export default CancelModal
